import { NavLink } from 'react-router';

export const SUPERADMIN_NAV_ITEMS = [
  { href: '/superadmin/overview', label: 'Overview', enabled: true },
  { href: '/superadmin/accounts', label: 'Accounts', enabled: false },
  { href: '/superadmin/organizations', label: 'Organizations', enabled: true },
  { href: '/superadmin/tenants', label: 'Tenants', enabled: true },
  { href: '/superadmin/users', label: 'Users', enabled: true },
  { href: '/superadmin/invitations', label: 'Invitations', enabled: true },
  { href: '/superadmin/billing', label: 'Billing', enabled: true },
  { href: '/superadmin/apps', label: 'Apps', enabled: true },
  { href: '/superadmin/entitlements', label: 'Entitlements', enabled: true },
  { href: '/superadmin/paddle-webhooks', label: 'Paddle Webhooks', enabled: true },
  { href: '/superadmin/operations', label: 'Operations', enabled: true },
  { href: '/superadmin/security', label: 'Security', enabled: true },
  { href: '/superadmin/health', label: 'Health', enabled: true },
] as const;

export function SuperadminSideNav() {
  return (
    <nav aria-label="Superadmin" className="flex flex-col gap-1">
      {SUPERADMIN_NAV_ITEMS.map((item) => {
        if (!item.enabled) {
          return (
            <span
              key={item.href}
              aria-disabled="true"
              className="flex items-center justify-between rounded-md px-3 py-2 text-sm text-muted-foreground opacity-70"
            >
              <span>{item.label}</span>
              <span className="rounded px-1.5 py-0.5 text-[10px] font-medium uppercase tracking-wide bg-muted text-muted-foreground">
                Coming soon
              </span>
            </span>
          );
        }

        return (
          <NavLink
            key={item.href}
            to={item.href}
            className={({ isActive }) =>
              `rounded-md px-3 py-2 text-sm transition-colors ${
                isActive
                  ? 'bg-muted text-foreground font-medium'
                  : 'text-muted-foreground hover:bg-muted/50 hover:text-foreground'
              }`
            }
          >
            {item.label}
          </NavLink>
        );
      })}
    </nav>
  );
}
